import {action, observable, computed} from 'mobx'
import {isUsedFreeDevice as isUsedFreeDeviceApi } from '@/services/Active'
import log from "@/utils/log";

class ActiveStore {
  @observable private showActive: boolean // 活动弹框显示
  @observable alreadyShowActive: boolean = false // 已经显示过活动弹框

  // 获取活动弹框显示状态
  @computed get getShowActive(): boolean {
    return this.showActive
  }

  // 获取用户领取免费实例情况
  @action.bound
  async isUsedFreeDevice() {
    if (this.alreadyShowActive) return ;
    const [error] = await isUsedFreeDeviceApi()
    if(error){
      log({eventId: 'E2301', pageId: 'P23', ext: ''})
      return ;
    }
    log({eventId: 'E2300', pageId: 'P23', ext: ''})
    this.onChangeShowActive(true)
  }

  // 修改活动弹框显示状态
  @action.bound
  onChangeShowActive(bool: boolean) {
    if(this.showActive && !bool) this.alreadyShowActive = true;
    this.showActive = bool
  }
}

export default ActiveStore
